export const parseTimezoneFromContact = (contact = {}) => {
  if (!contact) return null;
  // This function assumes that the address is inside an "addresses" array
  const { addresses = [] } = contact;
  if (!addresses || !addresses.length) return null;

  const primaryAddress = addresses.find((a) => a.primary);
  const address = primaryAddress || addresses[0];

  const { time_zone = {} } = address;
  if (!time_zone) return null;
  const { time_zone: tz = null } = time_zone;

  if (tz) {
    try {
      return new Date()
        .toLocaleTimeString("en-us", {
          timeZone: tz,
          timeZoneName: "short",
        }) // "00:00:00 PM PST"
        .split(" ")[2]; // split and just grab timezone
    } catch (e) {
      return null; // if for some reason it's not there, this will just return undefined
    }
  } else return null;
};
